import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { SplitComponent, SplitAreaDirective } from 'angular-split';
import * as L from 'leaflet';
import 'src/assets/js/maplib/L.control.HtmlLegend.js';
import 'src/assets/js/maplib/L.uGeoJson.js';
import 'src/assets/js/maplib/L.control.ZoomBar.js';
import 'src/assets/js/maplib/L.vectorgrid.bundle.js';
import { MapconstantsModule } from './mapconstants/mapconstants.module';
import { ConstantsModule } from 'src/app/common/constants/constants.module'
import { Layer } from './mapcontrol/layer';
import { Group } from './mapcontrol/group';
import { Groupgeojson } from './mapcontrol/groupgeojson'
import { GisService } from 'src/app/services/gis/gis.service';
import { BehaviorSubject, empty } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileLoginComponent } from '../../login/profile-login/profile-login.component';
import { LandingModelComponent } from 'src/app/common/ngbmodel/landing-model/landing-model.component';
import { AuthloginService } from 'src/app/services/login/authlogin.service';

@Component({
  selector: 'app-gis',
  templateUrl: './gis.component.html',
  styleUrls: ['./gis.component.css']
})
export class GisComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('split') split: SplitComponent;
  @ViewChild('area1') area1: SplitAreaDirective;
  @ViewChild('area2') area2: SplitAreaDirective;
  map: L.Map;
  stateList;
  baseLayers: Layer[] = [];
  OverlayLayers = {};
  layerObjects: Object = {};
  activeLayers: Object = {};

  parentLocName: string;
  activeBaseLayer: L.Layer;
  showLegend: boolean = true;
  legendData: Object;
  activeSpinner: boolean;
  logoutActive: boolean = false;
  htmlLegend;
  arealsize: number = 79;
  area2size: number = 21;
  userdetails;
  urlparams;
  currentZoomLevel: number;
  maptitlelabel: string
  statelatlng = {};
  statelocationdata = [];
  districtlocationdata = [];
  previousFeatureData: Object = {
    "id": null,
    "uuid": null,
    "layer": null
  };

  activeFeatureData: Object = {
    "id": null,
    "uuid": null,
    "layer": null
  };

  component: string;
  dashboardView: string;
  regionSelected: string;
  locSelected: string;
  srcSelected: string;
  showDataTab: boolean = false;
  myObserver;
  mobileDevice: boolean = false;
  sidebarArea: number = 70;
  infoArea: number = 30;
  attribution;
  userType;
  userName;
  userUUID;
  loginHeatMapGroupName;
  stopspinner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  mapLoaderActive: boolean;
  latlongobject: {};
  modalRef: any;
  logindetails: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private mapConstantsModule: MapconstantsModule,
    private gisService: GisService,
    private constants: ConstantsModule,
    private authService: AuthloginService,
    private modalService: NgbModal
  ) {
    translate.setDefaultLang('en');
    this.myObserver = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) { }
      if (event instanceof NavigationEnd) {
        if (this.map) {
          setTimeout(() => {
            this.initializeOnStateLoad();
          }, 100);
        }
      }
      if (event instanceof NavigationError) { }
    });
  }


  initializeOnStateLoad() {
    this.urlparams = this.getParams();
    this.gisService.setUrlData(this.urlparams);
    this.parentLocName = this.urlparams["parentLocName"];
    this.zoomtolocation();
    this.emptyLayers();
    this.logindetails = this.authService.checkloginstatus();
    //logindetails = {"login":"ehCW9Mr2Y7MFK8XPvdZmQ6K8FwMstVFbhDK36B3i5ACE1HS9aCi1QZV3UuaDClam+idCQgoYMYfFPdxTct9B8Ahbr/ktg2oz309l3jSSP7jZTsHbDvIN/LppcOEOEDKIPOqJtdrQ4Hvdzi2+3GVdMnCSR6mYGfB0tcWVQWPV/Z4=","accesssidetabs":["datasubmitapprovals","uploadexcel","downloadexcel","forminput","requestextension"],"roles":["DISTRICT_GANGA_COMMITTEE"],"sessionKey":null,"expirationTime":1651719317000,"loggedSuccess":true,"loggedOut":false,"loggedUserData":{"userProfile":{"userId":96,"lname":"District User","fname":"Aligarh","stateName":"UTTAR PRADESH","countryName":"INDIA","stateUUID":"0befe210-7397-4f2d-8f4f-26d8f04d2089","countryUUID":"ffce954d-24e1-494b-ba7e-0931d8ad6085","locationId":"00e49e35-1b42-46a2-b55b-da787b56a95b","locationName":"Aligarh","locationType":"DISTRICT","associatedlocationsDetails":[{"entityName":"Aligarh","entityUUID":"00e49e35-1b42-46a2-b55b-da787b56a95b","entityType":"DISTRICT"}]}}};
    if (this.logindetails) {
      this.addHighlightLayer(this.logindetails);
      this.addStateHighlightLayer(this.logindetails);
    }

    if (!this.parentLocName || !this.urlparams["locname"] || !this.urlparams["locuuid"] || !this.urlparams["loctype"]) {
      this.goToDefaultRoute(this.constants.VIEWS.ADMIN);
    } else {
      this.createLayers();
    }
  }

  addHighlightLayer(logindetails) {
    let distUUID = logindetails['loggedUserData']['userProfile']['locationId'];
    let filter = "loc_uuid = '" + distUUID + "'";
    let highlight = {
      url: this.mapConstantsModule.url,
      layerName: "gdpms:districts_new",
      style: "gdpms:dist_highlight",
      attribution: "",
      minZoom: 3,
      maxZoom: 12,
      pane: 'district',
      // cql_filter:'1=1',
      type: 'WMS',
      name: 'Highlight',
      displayName: "India Boundary",
      default_display: true,
      cql_filter: filter

    }
    this.layerObjects[highlight.name] = this.gisService.addWMSLayer(highlight);
    if (this.map) {
      this.map.addLayer(this.layerObjects[highlight.name]);
    }
    this.gisService.getBlock(filter).subscribe((data: GeoJSON.GeoJsonObject) => {
    
      // Ensure features exist and is not empty
      if (data && 'features' in data && Array.isArray((data as any).features) && (data as any).features.length > 0) {
        const feature = (data as any).features[0];
        const lat = feature.properties.latitude;
        const lng = feature.properties.longitude;
    
        this.map.setView([lat, lng], 9);
      } else {
        console.error('No features found in GeoJSON data');
      }
    });
  }

  addStateHighlightLayer(logindetails) {
    let distUUID = logindetails['loggedUserData']['userProfile']['locationId'];
    let filter = "loc_uuid = '" + distUUID + "'";
    let highlight = {
      url: this.mapConstantsModule.url,
      layerName: "gdpms:states",
      style: "gdpms:state_boundary",
      attribution: "",
      minZoom: 3,
      maxZoom: 12,
      pane: 'state_highlight',
      // cql_filter:'1=1',
      type: 'WMS',
      name: 'Highlight',
      displayName: "State Boundary",
      default_display: true,
      cql_filter: filter

    }
    this.layerObjects[highlight.name] = this.gisService.addWMSLayer(highlight);
    if (this.map) {
      this.map.addLayer(this.layerObjects[highlight.name]);
    }
    this.gisService.getBlock(filter).subscribe((data: GeoJSON.GeoJsonObject) => {
    
      // Ensure features exist and is not empty
      if (data && 'features' in data && Array.isArray((data as any).features) && (data as any).features.length > 0) {
        const feature = (data as any).features[0];
        const lat = feature.properties.latitude;
        const lng = feature.properties.longitude;
    
        this.map.setView([lat, lng], 9);
      } else {
        // console.error('No features found in GeoJSON data');
      }
    });
  }

  emptyLayers() {
    Object.keys(this.layerObjects).forEach(key => {
      if (this.map && this.layerObjects[key] && this.map.hasLayer(this.layerObjects[key])) {
        this.map.removeLayer(this.layerObjects[key]);
      }
    });
    this.layerObjects = {};
    this.OverlayLayers = {};
  }

  getParams() {
    // console.log('params',this.route.snapshot.params);
    return this.getWritableObject(this.route.snapshot.params);
  }

  zoomtolocation() {
    if (this.map) {
      // this.map.setView([23.87155, 76.01109], 5);
      this.map.setView([26, 80], 6);

    }
  }

  goToDefaultRoute(view: String) {
    let urlParams = { "locname": "INDIA", "loctype": this.constants.LOCATION_CONSTANT.COUNTRY, "view": view || this.constants.VIEWS.ADMIN, "locuuid": "ffce954d-24e1-494b-ba7e-0931d8ad6085", "mapOnClickParams": "false" };
    this.router.navigate(["/gis", this.constants.DEFAULT_COUNTRY, urlParams]);
  }

  ngOnDestroy() {
    this.myObserver.unsubscribe();
  }

  async ngOnInit() {
    this.initializeMap();
    this.setSplitAreaRatio();
    // this.profileCreation();
  }
  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.initializeMap();
    //   this.setSplitAreaRatio();
    // }, 100);

  }

  initializeMap() {
    this.addMap();
    this.createPanes();
    this.addHTMLLegend();
    this.revalidateMap();
    this.currentZoomLevel = this.map.getZoom();
    this.initializeOnStateLoad();
  }

  addMap() {
    this.map = L.map('mapid', { minZoom: 4, maxZoom: 12, zoomControl: true });
    // this.map.setView([23.87155, 76.01109], 5);
    this.map.setView([26, 80], 6);
    this.map.scrollWheelZoom.disable();
    this.addZoomBar(this.map);
    this.zoomtolocation();
    this.addTileLayer();
  }

  toggleArea() {
    this.arealsize = this.arealsize == 70 ? 100 : 70;
    this.area2size = this.area2size == 30 ? 0 : 30;
  }
  profileCreation() {
    this.modalRef = this.modalService.open(ProfileLoginComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  approvalinfo', size: 'lg' });
  }

  createPanes() {
    this.mapConstantsModule.PANE_LIST.forEach(pane => {
      this.map.createPane(pane.name);
      this.map.getPane(pane.name).style.zIndex = pane.zindex;
    });
  }

  addHTMLLegend() {
    let legend = (L as any).control.htmllegend({
      position: 'bottomright',
      collapseSimple: true,
      detectStretched: true,
      collapsedOnInit: false,
    });
    this.map.addControl(legend);
    this.htmlLegend = legend;
  }

  addZoomBar(map: L.Map) {
    let zoomBarControl = new (L as any).control.zoomBar();
    if (map) {
      let Map = Object.assign({}, map);
      zoomBarControl.addTo(map);
    }
  }
  changeBaseLayer(layerName: string) {

    this.map.removeLayer(this.activeBaseLayer);
    this.map.addLayer(this.layerObjects[layerName]);
    this.activeBaseLayer = this.layerObjects[layerName]
  }

  revalidateMap(): void {
    if (this.map) { setTimeout(() => { this.map.invalidateSize(); }, 200); }
  }

  resetSplitArea(status: string) {
    if (status == 'close') {
      this.infoArea = 0;
      this.sidebarArea = 100;
    } else if (status == 'open') {
      this.infoArea = 100;
      this.sidebarArea = 0;
    }
  }

  toggleLayer(layerName: string) {
    if (this.activeLayers[layerName]) {
      this.map.addLayer(this.layerObjects[layerName]);
    } else {
      this.map.removeLayer(this.layerObjects[layerName]);
    }
  }

  addTileLayer() {
    // let tileLayer = new L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
    let tileLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png', {
      "maxZoom": 20,
      "maxNativeZoom": 17
    });
    this.map.addLayer(tileLayer);
  }

  getWritableObject(obj: object): object {
    if (obj == null || obj == undefined) return obj;
    let objectConfig = {};
    for (let key in obj) {
      objectConfig[key] = obj[key];
    }
    // console.log('objectconfig',objectConfig);
    return objectConfig;
  }

  addLayersToMap(layerNameList: string[]) {
    layerNameList.forEach(layerName => {
      if (this.layerObjects[layerName] != undefined) {
        this.map.addLayer(this.layerObjects[layerName]);
        this.activeLayers[layerName] = true;
      }
    });
  }

  removeLayersFromMap(layerNameList: string[]) {
    layerNameList.forEach(layerName => {
      if (this.layerObjects[layerName] != undefined) {
        this.map.removeLayer(this.layerObjects[layerName]);
        this.activeLayers[layerName] = false;
      }
    });
  }

  addLayerToGroup(layer, groupName) {
    if (!this.OverlayLayers.hasOwnProperty(groupName)) {
      this.OverlayLayers[groupName] = [];
    }
    this.OverlayLayers[groupName].push(layer);
  }

  createLayers() {
    this.mapConstantsModule.layer_list.forEach(group => {
      group.layerList.forEach(async layer => {
        let layerProperties = { name: layer.name, displayName: layer.displayName }
        if (layer['type'] == 'WMS') {
          this.addLayerToGroup(layerProperties, group.groupName);
          this.layerObjects[layer.name] = this.gisService.addWMSLayer(layer);
          if (this.map && layer.default_display == true) {
            this.activeLayers[layer.name] = true;
            this.map.addLayer(this.layerObjects[layer.name]);
          } else {
            this.activeLayers[layer.name] = false;
          }
        } else if (layer['type'] == 'VECTOR1') {
          this.addLayerToGroup(layerProperties, group.groupName);
          //console.log("in if  condition");
          this.activeSpinner = true;

          let rankData = null;
          // rankData = await this.gisService.getLocationRanking(this.gisService.getRankingParams(this.getParams())).toPromise();
          // console.log(rankData);

          this.activeSpinner = false;
          // rankData = await this.gisService.getMeeting().toPromise();
          let layerObj = this.gisService.addVectorLayer(layer, this.map, this.activeLayers, null, false, rankData, this.logindetails);
          // console.log('layer objectt1233333333',layerObj);
          Object.assign(this.layerObjects, layerObj);
          this.activeLayers["DISTRICT"] = true;
          if (this.activeLayers['DISTRICTBASIN'] && !this.activeLayers['DISTRICT']) {
            this.gisService.addLegendToModal("DISTRICT", layerObj[layer.layer_name], this.htmlLegend);
          }
          else if (!this.activeLayers['DISTRICTBASIN'] && this.activeLayers['DISTRICT']) {

            this.gisService.addLegendToModal("DISTRICT", layerObj[layer.layer_name], this.htmlLegend);
          }
          //console.log("htmlLegend :::",this.htmlLegend);
          this.htmlLegend.expandContainer();

        } else if (layer['type'] == 'VECTOR2') {
          // console.log("vector2"); 
          if (this.logindetails) {
            this.addLayerToGroup(layerProperties, group.groupName);

            this.activeSpinner = true;

            let rankData = null;
            rankData = await this.gisService.getMeeting().toPromise();
            this.activeSpinner = false;
            let layerObj = this.gisService.addVectorLayer(layer, this.map, this.activeLayers, null, false, rankData, this.logindetails);
            Object.assign(this.layerObjects, layerObj);
            this.activeLayers["DISTRICT_ATTENDENCE"] = false;

            this.gisService.addLegendToModal("DISTRICT_ATTENDENCE", layerObj[layer.layer_name], this.htmlLegend);
            //console.log("htmlLegend :::",this.htmlLegend);
            this.htmlLegend.expandContainer();
          } else {
            delete this.OverlayLayers[group.groupName]
            // to remove if layer was added due to login previously
            if (this.layerObjects.hasOwnProperty("DISTRICT_ATTENDENCE")) {
              if (this.map.hasLayer(this.layerObjects["DISTRICT_ATTENDENCE"])) {
                this.map.removeLayer(this.layerObjects["DISTRICT_ATTENDENCE"]);
              }
            }
          }
        }
      });
    });
  }

  getBoundString(extent: L.LatLngBounds) {
    let corner1 = L.latLng(extent['_northEast']['lat'], extent['_northEast']['lng']);
    let corner2 = L.latLng(extent['_southWest'].lat, extent['_southWest']['lng']);
    let bounds = L.latLngBounds(corner1, corner2);
    return bounds;
  }

  getBoundsFromString(boundString: string) {
    if (boundString) {
      let extent = boundString.split("#");
      let bounds = L.latLng(parseFloat(extent[0]), parseFloat(extent[1]));
      return bounds;
    }
  }

  setBounds(boundString, zoom) {
    let bounds = this.getBoundsFromString(boundString);
    if (!zoom) {
      zoom = this.map.getZoom();
    }
    if (bounds) {
      this.map.setView(bounds, zoom);
    } else {
      this.setDefaultView();
    }
  }


  setstopspinner(value) {
    this.stopspinner.next(value);
  }

  getstopspinner() {
    return this.stopspinner.asObservable();
  }

  getBrowserWidth() {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return width;
  }

  setSplitAreaRatio() {
    var width = this.getBrowserWidth();
    if (width < 1400) {
      this.arealsize = 79
      this.area2size = 21;
    }
    else if (width < 1700) {
      this.arealsize = 70;
      this.area2size = 30;
    }
  }

  setDefaultView() {
    // this.map.setView([23.87155, 76.01109], 5);
    this.map.setView([26, 80], 6);
  }
  getDefaultBounds() {
    return "" + 4.959615024698026 + "#" + 37.61718750000001 + "#" + 40.613952441166596 + "#" + 118.38867187500001 + ""
  }
  toggleFullScreen() {
    (this.map as any).toggleFullscreen()
  }
}

